import axios from 'axios';
import config from '../config';
import { isPublicRoute } from '../utils/authUtils';
const API_URL = config.VITE_API_URL_v1;

// Create axios instance with default config
const api = axios.create({
    baseURL: API_URL,
    timeout: 900000, // Увеличено до 15 минут
    withCredentials: true,
    headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json',
    },
});

api.interceptors.response.use(
    (response) => response,
    async (error) => {
        const originalRequest = error.config;

        // Retry для broken pipe и timeouts
        if ((error.code === 'ECONNABORTED' || error.message.includes('timeout')) 
            && !originalRequest._retryCount) {
            originalRequest._retryCount = 1;
            await new Promise(resolve => setTimeout(resolve, 3000));
            return api(originalRequest);
        }
        
        // Retry для 429
        if (error.response?.status === 429 && !originalRequest._retryCount) {
            originalRequest._retryCount = 1;
            await new Promise(resolve => setTimeout(resolve, 5000));
            return api(originalRequest);
        }

        if (error.response?.status === 401 && !originalRequest._retry) {
            originalRequest._retry = true;

            try {
                // Use cookies: refresh token is in HttpOnly cookie
                await axios.post(`${API_URL}/auth/token/refresh/`, {}, {
                    withCredentials: true
                });

                // Retry original request (cookies will carry new access token)
                return api(originalRequest);
            } catch (refreshError) {
                console.error("Refresh failed", refreshError);
                // prevent infinite redirect loop                
                if (!isPublicRoute(window.location.pathname) && window.location.pathname !== "/login") {
                    window.location.href = '/login';
        }
                return Promise.reject(refreshError);
            }
        }

        return Promise.reject(error);
    }
);


export default api;